import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'BBM Appliances | #1 Appliance Repair & Parts in PA & NJ | Same-Day Service',
  description = 'BBM Appliances - Pennsylvania & New Jersey\'s top-rated appliance repair service. Same-day washer, dryer, refrigerator, oven repair. Professional technicians. Appliance parts available. Call (855) 605-6034!',
  canonical = 'https://www.bbmappliances.com',
  type = 'website',
  keywords = 'appliance repair, appliance parts, washer repair, dryer repair, refrigerator repair, PA, NJ, Philadelphia'
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content="https://customer-assets.emergentagent.com/job_home-fix-pros-3/artifacts/7ckw9a8p_LOGO%20BBM.png" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://customer-assets.emergentagent.com/job_home-fix-pros-3/artifacts/7ckw9a8p_LOGO%20BBM.png" />
    </Helmet>
  );
};

export default SEO;
